import makeApiCall from '../../../services/apiService/apiService';

export const test1 = 'test1';
export const userData = 'user_data';

export const test1ActionCreator = data => ({
  type: test1,
  payload: `txt from action creator and ${data}`
});

export const test1AsyncActionCreatorRequest = data => ({
  type: userData,
  payload: data
});

// sample paramObj = {
//         method: 'GET',
//         apiNamespace: 'zoomInfoUrl',
//         replaceParamsArr: [{key:'{locationCode}', val: data.locationCode}, {key: '{timestamp}', val: data.at}],
//         apiEndPoint: incomingLoadApiEndPoint,
//         data : data,
//         successCb: function,
//         failureCb: function,
//         catchCb: function
//       }

export const test1AsyncActionCreator = num => dispatch => {
  dispatch(test1AsyncActionCreatorRequest('Loading'));

  const requestObj = {
    apiEndPoint: 'sampleRoute1',
    replaceParamsArr: [{ key: ':param', val: num }],
    successCb: res => {
      // eslint-disable-next-line no-console
      console.log(' test1AsyncActionCreator successCb, res= ', res);
      dispatch(test1AsyncActionCreatorRequest('from successCb'));
    },
    failureCb: res => {
      // eslint-disable-next-line no-console
      console.log(' test1AsyncActionCreator failureCb, res= ', res);
      dispatch(test1AsyncActionCreatorRequest('from failureCb'));
    },
    catchCb: res => {
      // eslint-disable-next-line no-console
      console.log(' test1AsyncActionCreator successCb, err= ', res);
      dispatch(test1AsyncActionCreatorRequest('from catchCb'));
    }
  };

  return makeApiCall(requestObj);
};
